var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113425",
    "data-name": "Rectangle 113425",
    width: 45.226,
    height: 45.234,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_334304",
    "data-name": "Group 334304",
    transform: "translate(7709 -29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114334",
    "data-name": "Rectangle 114334",
    width: 72,
    height: 72,
    transform: "translate(-7709 29)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_334300",
    "data-name": "Group 334300",
    transform: "translate(-7695.613 45.09)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113423",
    "data-name": "Rectangle 113423",
    width: 17.629,
    height: 17.034,
    transform: "translate(22.74 22.537)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_332125",
    "data-name": "Group 332125",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332124",
    "data-name": "Group 332124",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337446",
    "data-name": "Path 337446",
    d: "M27.965,43.335a15.291,15.291,0,0,1-3.66-.941,13.553,13.553,0,0,1-8.627-10.978,13.917,13.917,0,0,1,27.5-4.309l.152.867v2.913c-.02.085-.047.169-.059.256A13.768,13.768,0,0,1,34.578,42.4a14.96,14.96,0,0,1-3.7.937Zm.5-10.652h0c-1.029,0-2.06-.008-3.089,0a1.3,1.3,0,1,0-.01,2.579c1.25.011,2.5.015,3.751,0a23.24,23.24,0,0,0,2.864-.063A4.819,4.819,0,0,0,36.1,32.041a4.955,4.955,0,0,0-.946-5.35,5.035,5.035,0,0,0-3.888-1.685c-1.058-.017-2.118,0-3.178-.006-.1,0-.228.04-.278-.07s.07-.181.136-.25c.182-.193.381-.37.553-.57a1.269,1.269,0,0,0-.049-1.757,1.245,1.245,0,0,0-1.754-.006q-1.549,1.509-3.058,3.059a1.259,1.259,0,0,0,0,1.793q1.51,1.547,3.061,3.055a1.252,1.252,0,0,0,1.756-.011,1.271,1.271,0,0,0,.016-1.789c-.157-.174-.333-.331-.5-.5-.076-.082-.222-.152-.174-.279s.205-.079.314-.08c1.1,0,2.207-.008,3.31,0a2.545,2.545,0,0,1-.007,5.089c-.986.007-1.971,0-2.957,0",
    transform: "translate(1.901 1.899)",
    fill: "#d0d9de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113424",
    "data-name": "Rectangle 113424",
    width: 13.964,
    height: 11.688,
    transform: "translate(12.143 0.003)",
    fill: "#1a2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337447",
    "data-name": "Path 337447",
    d: "M37.58,1.515v14c0,.561-.022.572-.539.382a16.464,16.464,0,0,0-21.787,11.92,16.2,16.2,0,0,0,.617,9.2c.2.55.2.561-.382.561-4.658,0-9.316.011-13.986,0A1.349,1.349,0,0,1,0,36.053V1.628C0,.483.471,0,1.639,0H11.92c.584,0,.584.011.584.584q0,4.529.011,9.047a3.743,3.743,0,0,0,.045.707,1.235,1.235,0,0,0,1.751.92c.539-.236,1.055-.528,1.583-.8.819-.415,1.661-.819,2.469-1.257a.826.826,0,0,1,.864.011c1.235.64,2.5,1.246,3.727,1.919a1.361,1.361,0,0,0,2.121-1.3c-.022-3.076-.011-6.151-.011-9.227,0-.595.011-.606.617-.606h10.36A1.36,1.36,0,0,1,37.58,1.515",
    transform: "translate(0 -0.001)",
    fill: "#d0d9de"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2);
export default __webpack_public_path__ + "static/media/g2.9c58f8f1b8a755512ac55d5a82c1bb1b.svg";
export { ForwardRef as ReactComponent };